'use client';

// Next Imports
import Link from 'next/link';

// MUI Imports
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const NotFound = () => {
    // Vars
    const Image_404 = '/images/illustrations/auth/404_image.png';

    return (
        <div className='flex items-center justify-center min-bs-[100dvh] relative p-6 overflow-x-hidden'>
            <div className='flex items-center flex-col text-center gap-10'>
                <div className='flex flex-col gap-2 is-[90vw] sm:is-[unset]'>
                    <Typography variant='h4'>
                        ⚠️ Oops! Trang bạn đang tìm không tồn tại.
                    </Typography>
                </div>
                <img
                    alt='error-illustration'
                    src={Image_404}
                    className='object-cover bs-[400px] md:bs-[450px] lg:bs-[500px]'
                />
                <Button href='/' component={Link} variant='contained'>
                    Quay về trang chủ
                </Button>
            </div>
        </div>
    );
};

export default NotFound;
